import React from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {Grid, Header, Card, Divider, Label, Item} from 'semantic-ui-react';
import _ from 'lodash';

export class ContactsCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      grantContact: props.grantContacts,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.state.applicationContact === undefined &&
      _.get(this.props, 'applicationDynamicData.payload') !== undefined
    ) {
      // TODO, refactor to pass preparerInfo and contacts directly as props, but need to refactor all configs
      this.setState({
        grantWriter: _.get(
          this.props,
          'applicationDynamicData.payload.requestInformation.preparerInfo'
        ),
        applicationContact: _.get(
          this.props,
          'applicationDynamicData.payload.contacts',
          _.get(this.props, 'subApplication.payload.contacts', [])
        ),
      });
    }
  }

  prepareContact = (contact, contactType) => {
    let display = {};
    
    if (contactType === 'contact' || contactType === 'signed') {
      display.name = contact.firstName + ' ' + contact.lastName;
      display.title = contact.title;
      display.email = contactType === 'signed' ? (contact.emailAdr ? contact.emailAdr : contact.userId) : (contact.emailAdr ? contact.emailAdr: contact.email);
      display.phone = contact.phoneNumber;
      if (contact.extension && contact.extension !== '') {
        display.phone = display.phone + ' ext.' + contact.extension;
      }

      display.secondaryPhone = contact.secondaryPhoneNumber;
      if (contact.secondaryPhoneExt && contact.secondaryPhoneExt !== '') {
        display.secondaryPhone =
          display.secondaryPhone + ' ext.' + contact.secondaryPhoneExt;
      }
    } else {
      //Grant Writer
      display.name = contact.name;
      display.email = contact.email;
      display.phone = contact.phoneNumber;
      display.address1 = contact.address1;
      display.address2 = contact.address2;
      display.city = contact.city;
      if (contact.state) {
        display.city = display.city + ', ' + contact.state;
      }
      if (contact.zip) {
        display.city = display.city + ' ' + contact.zip;
      }
    }

    return display;
  };

  prepareData = () => {
    const {grantWriter, applicationContact} = this.state;
    const {grantContacts, signedInfo} = this.props;

    let returnMe = {};
    let primaryContactObject;
    let alternateContactObject;

    if (grantContacts != undefined) {
      primaryContactObject = _.find(grantContacts, (p) => {
        return p && p.type === 'primary';
      });
      alternateContactObject = _.filter(grantContacts, (p) => {
        return p && p.type == 'alternate';
      });
    } else if (applicationContact !== undefined) {
      primaryContactObject = _.find(applicationContact, (p) => {
        return p && p.type == 'primary';
      });
      alternateContactObject = _.filter(applicationContact, (p) => {
        return p && p.type == 'alternate';
      });
    }

    if (primaryContactObject !== undefined) {
      //Populate primary contact
      returnMe.primaryContact = this.prepareContact(primaryContactObject, 'contact');
    }

    //Populate alternate contact
    let alternateContactData = [];
    if (alternateContactObject !== undefined) {
      _.forEach(alternateContactObject, (curr) => {
        let altContact = this.prepareContact(curr, 'contact');
        alternateContactData.push(altContact);
      });
      returnMe.alternateContact = alternateContactData;
    }

    //Populate signedInfo
    if (signedInfo !== undefined) {
      returnMe.signedInfo = this.prepareContact(signedInfo, 'signed');
    }

    //Populate Grant Writer
    if (grantWriter !== undefined) {
      returnMe.grantWriter = this.prepareContact(grantWriter, 'grantWriter');
    }

    return returnMe;
  };

  renderContactData = (header, contactData) => {
    const toggles = _.get(this.props, "context.toggles.toggles", []);
    const emailLabel = _.includes(toggles, 'loginGovIntegration') ? "Email for notification:" : "Email:";

    if (!_.isEmpty(contactData) && !_.isUndefined(contactData)) {
      return (
        <Grid.Column>
          <Card.Header>
            <b>{header}</b>
          </Card.Header>
          <Card.Content>Name: {contactData.name || 'N/A'}</Card.Content>
          <Card.Content>Title: {contactData.title || 'N/A'}</Card.Content>
          <Card.Content>{emailLabel} {contactData.email || 'N/A'}</Card.Content>
          <Card.Content>Primary phone: {contactData.phone || 'N/A'}</Card.Content>
          <Card.Content>
            Secondary phone: {contactData.secondaryPhone || 'N/A'}
          </Card.Content>
        </Grid.Column>
      );
    }
  };

  renderGrantWriter = (header, contactData) => {
    return (
      <Grid.Column>
        <Card.Header>
          <b>{header}</b>
        </Card.Header>
        <Card.Content>Preparer's Name: {contactData.name || 'N/A'}</Card.Content>
        <Card.Content>Email: {contactData.email || 'N/A'}</Card.Content>
        <Card.Content>Primary phone: {contactData.phone || 'N/A'}</Card.Content>
        <Card.Content>Address: {contactData.address1}</Card.Content>
        <Card.Content>{contactData.address2}</Card.Content>
        <Card.Content>{contactData.city}</Card.Content>
      </Grid.Column>
    );
  };

  render() {
    const contactJson = JSON.parse(JSON.stringify(this.prepareData()));
    const organizationName = this.props.organizationName;
    const subOrganizationName = this.props.subOrganizationName;
    const subGrantIdExists = !_.isUndefined(_.get(this.props, 'subGrantId'));

    return (
      <React.Fragment>
        <Grid columns={2} padded={false}>
          <Item>
            <Item.Content>
              <b>
                {subGrantIdExists === true
                  ? 'Subrecipient Organization:'
                  : 'Recipient Organization:'}
              </b>{' '}
              {subGrantIdExists === true
                  ? subOrganizationName
                  : organizationName}
            </Item.Content>
          </Item>
          <Grid.Row padded={false}>
            {contactJson !== undefined &&
              contactJson.primaryContact !== undefined &&
              this.renderContactData(
                subGrantIdExists === true
                  ? 'Subgrant point of contact'
                  : 'Grant point of contact',
                subGrantIdExists === true
                  ? contactJson.signedInfo
                  : contactJson.primaryContact
              )}
            {contactJson !== undefined &&
              contactJson.alternateContact !== undefined &&
              contactJson.alternateContact[0] !== undefined &&
              subGrantIdExists !== true &&
              this.renderContactData(
                'Alternate contact 1',
                contactJson.alternateContact[0]
              )}
          </Grid.Row>
          <Grid.Row padded={false}>
            {contactJson !== undefined &&
              contactJson.alternateContact !== undefined &&
              contactJson.alternateContact[1] !== undefined &&
              subGrantIdExists !== true &&
              this.renderContactData(
                'Alternate contact 2',
                contactJson.alternateContact[1]
              )}
            {contactJson !== undefined &&
              contactJson.grantWriter !== undefined &&
              this.renderGrantWriter('Grant Writer', contactJson.grantWriter)}
          </Grid.Row>
        </Grid>
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  const returnObject = {
    token: state.auth.token,
    grantContacts: _.get(state.dynamicComponent.context, 'grant.payload.contacts'),
    organizationName: _.get(state.dynamicComponent.context, 'organization.displayName'),
    subOrganizationName: _.get(state.dynamicComponent.context, 'subOrganization.displayName'),
    applicationDynamicData: _.get(
      state.dynamicComponent.context,
      'applicationDynamicData'
    ),
  };

  return returnObject;
};
export const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(connectDynamic(ContactsCard));
